'use client';

import { ReactNode } from 'react';
import { cn } from '@app/ui/_lib/utils';
import { useInView } from 'react-intersection-observer';

type EmProps = {
	children: ReactNode;
	highlight?: boolean;
	highlightGradient?: boolean;
	highlightText?: boolean;
};

export function Em(props: EmProps) {
	const { ref, inView } = useInView({
		threshold: 1,
		triggerOnce: true,
		delay: 500,
	});

	if (props.highlightText === true) {
		return <span className='text-foreground-brand-primary'>{props.children}</span>;
	}

	if (props.highlight === true) {
		return (
			<span ref={ref} className={cn('rounded-md px-2 box-decoration-clone', inView ? 'highlight' : '')}>
				{props.children}
			</span>
		);
	}

	if (props.highlightGradient === true) {
		return (
			<span className='relative inline-block text-white'>
				{props.children}
				<span className='highlight-gradient' />
				<span className='highlight-gradient-underline' />
			</span>
		);
	}

	return <em className={`font-poppins font-normal`}>{props.children}</em>;
}
